<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" epub:type="chapter" id="unnumbered-1" role="doc-chapter">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-mixed">SEPTEMBER 2019</h1>
</div>
<h2 class="element-subtitle case-upper">SUNDAY</h2>
</div>
</div>
</div>
<div class="text" id="unnumbered-1-text">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// september-2019.vue?f885a8fe